import { getToken } from '@api/getToken';
import { useTokenStore } from '@store/TokenStore';
import { useTrackingStore } from '@store/TrackingStore';
import { useCallback} from 'react';

export function useTracking() {
  const { setToken } = useTokenStore();
  const { setTracking } = useTrackingStore();

  const getTrackingAndToken = useCallback(async () => {
    const data = await getToken();
    await setToken(data);
    await setTracking(data);
  }, []);

  return {getTrackingAndToken}
}
